import { ErrorTypeEnum } from '../shared/enums.model';

export class ErrorObject {
    constructor( public errorText: string,
        public originator: string,
        public errType: ErrorTypeEnum ) {
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/errorhandler/gpiserror-object.ts